import type { WeeklyPlan, WeeklyPlanForm } from '@/api/planning/weekly-plans';

// Local form shape: useFixedTime is a transient toggle (fixed time XOR window),
// stripped before sending. Mirrors the route-plan wizard's per-visit timing toggle.
export interface WeeklyPlanFormValues extends WeeklyPlanForm {
  useFixedTime: boolean;
}

export function weeklyPlanDefaults(): WeeklyPlanFormValues {
  return {
    days: [], durationMin: null, useFixedTime: true,
    fixedStartTime: null, timeWindowStart: null, timeWindowEnd: null, caregiverId: null,
  };
}

export function weeklyPlanFromPlan(plan: WeeklyPlan): WeeklyPlanFormValues {
  return {
    days: [...plan.days],
    durationMin: plan.durationMin ?? null,
    // Window mode only when a window is stored; otherwise default to fixed-time mode.
    useFixedTime: !plan.timeWindowStart,
    fixedStartTime: plan.fixedStartTime || null,
    timeWindowStart: plan.timeWindowStart || null,
    timeWindowEnd: plan.timeWindowEnd || null,
    caregiverId: plan.caregiverId ?? null,
  };
}

function blankToNull<T>(value: T | null | undefined): T | null {
  return value || null;
}

// Send only the active timing pair so the backend's fixed-XOR-window invariant holds.
export function toWeeklyPlanPayload(values: WeeklyPlanFormValues): WeeklyPlanForm {
  const fixed = values.useFixedTime;
  return {
    days: values.days,
    durationMin: blankToNull(values.durationMin),
    caregiverId: values.caregiverId ?? null,
    fixedStartTime: fixed ? blankToNull(values.fixedStartTime) : null,
    timeWindowStart: fixed ? null : blankToNull(values.timeWindowStart),
    timeWindowEnd: fixed ? null : blankToNull(values.timeWindowEnd),
  };
}
